export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-edit-b9603154cf6a1ac98758f7384d881be0.svg";